import { render } from "./footer.vue?vue&type=template&id=6b36d80d&scoped=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=6b36d80d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b36d80d"

export default script